import React from "react";

const CategoryIcon = () => {
  return (
<svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.375 6.24991C13.8247 6.24991 14.9999 5.07468 14.9999 3.62495C14.9999 2.17523 13.8247 1 12.375 1C10.9252 1 9.75 2.17523 9.75 3.62495C9.75 5.07468 10.9252 6.24991 12.375 6.24991Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.62495 14.9999C5.07468 14.9999 6.24991 13.8247 6.24991 12.375C6.24991 10.9252 5.07468 9.75 3.62495 9.75C2.17523 9.75 1 10.9252 1 12.375C1 13.8247 2.17523 14.9999 3.62495 14.9999Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.74985 9.74985H14.9998V14.1248C14.9998 14.3568 14.9076 14.5794 14.7435 14.7435C14.5794 14.9076 14.3568 14.9998 14.1248 14.9998H10.6248C10.3928 14.9998 10.1702 14.9076 10.0061 14.7435C9.84203 14.5794 9.74985 14.3568 9.74985 14.1248V9.74985ZM1 1H6.24991V5.37492C6.24991 5.60698 6.15772 5.82954 5.99363 5.99363C5.82954 6.15772 5.60698 6.24991 5.37492 6.24991H1.87498C1.64292 6.24991 1.42037 6.15772 1.25628 5.99363C1.09219 5.82954 1 5.60698 1 5.37492V1Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


  );
};

export default CategoryIcon;